module.exports = __webpack_public_path__ + "static/img/11.3c67ac9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/zh/11.png
// module id = W5GB
// module chunks = 0